import redact from "./_redact";

const sendExternalEvent = (url) => {};

export default sendExternalEvent;
